var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M20.1498 8.19003L8.27978 20.0601C7.21978 21.1301 4.04977 21.62 3.32977 20.91C2.60977 20.2 3.11978 17.0301 4.17978 15.9601L16.0498 4.09006C16.5979 3.56807 17.3283 3.28103 18.0851 3.29025C18.842 3.29948 19.5652 3.60424 20.1004 4.13944C20.6356 4.67463 20.9403 5.39787 20.9496 6.15469C20.9588 6.91152 20.6718 7.64195 20.1498 8.19003Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.336e740eb40ea73bc9cf9558dd3461ee.svg";
export { ForwardRef as ReactComponent };